import TwoColumnLayout from "layout/TwoColumnLayout";
import moment from "moment";
import React, { useState } from "react";
import { useLoaderData } from "react-router";
import { ItineraryExportSection } from "./ItineraryFiltersSection";
import { ItineraryExportFor, ItineraryExportForm, ItineraryExportOptions } from "./model";
import { ExportPanel } from "./ExportPanel";
import { useCustomQuery } from "utilities/hookutils";

const getForFromViewModel = (viewModel: server.viewmodel.ItineraryFrontModel): ItineraryExportFor => {
  if (viewModel.selectedArtists.length > 0) {
    return "artist";
  } else if (viewModel.selectedContacts.length > 0) {
    return "contact";
  } else if (viewModel.selectedProductions.length > 0) {
    return "production";
  }

  return "artist"; // Default to artist if nothing is selected
}

export const PlanningItineraryApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ItineraryFrontModel>();

  const [formState, setFormState] = useState<ItineraryExportForm>({
    for: getForFromViewModel(viewModel),
    artists: viewModel.selectedArtists,
    contacts: viewModel.selectedContacts,
    productions: viewModel.selectedProductions,
    date: {
      start: moment.utc(viewModel.start),
      end: moment.utc(viewModel.end)
    },
    phases: viewModel.selectedAppointmentPhases,
    appointmentTypes: viewModel.selectedAppointmentTypes
  });
  const [options, setOptions] = useState<ItineraryExportOptions>({
    displayCosts: viewModel.displayCosts,
    displaySales: viewModel.displaySales,
    culture: viewModel.culture,
  });

  const query = useCustomQuery({
    queryFn: async () => (await window.CoreApi.Itinerary.Count(mapToDto(formState, options))).data,
    queryKey: [formState],
    keepPreviousData: true
  });

  const onFormChange = async (form: ItineraryExportForm) => {
    setFormState(form);
  }

  const onOptionsChange = (options: ItineraryExportOptions) => {
    setOptions(options);
  }

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ItineraryExportSection
        formState={formState}
        options={options}
        onFormChange={onFormChange}
        onOptionsChange={onOptionsChange}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <ExportPanel
        isLoading={query.isFetching}
        errors={query.isInitialLoading ? viewModel.peekItineraryExport.errors : query.data.errors}
        count={query.isInitialLoading ? viewModel.peekItineraryExport.data : query.data.data}
        dto={mapToDto(formState, options)}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

const mapToDto = (formState: ItineraryExportForm, options: ItineraryExportOptions): server.dto.ExportItineraryInstruction => ({
  artistIds: formState.artists.map(a => a.artistId),
  contactIds: formState.contacts.map(c => c.contactId),
  culture: options.culture,
  displayCosts: options.displayCosts,
  displaySales: options.displaySales,
  productionIds: formState.productions.map(p => p.productionId),
  end: formState.date.end.toDate(),
  phases: formState.phases,
  start: formState.date.start.toDate(),
  types: formState.appointmentTypes,
});